import { ArrowUpRight } from "lucide-react";
import { Chapter, Reveal } from "@/components/motion";
import { INDUSTRIES } from "@/data/site";

export default function Industries() {
  return (
    <section className="bg-surface py-28 lg:py-36" data-testid="industries-section">
      <div className="mx-auto max-w-7xl px-6">
        <Chapter index="04" label="Industries We Support" />
        <div className="mt-8 grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Reveal delay={0.1}>
              <h2 className="font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl">
                Supporting Australia's <span className="text-gold">Construction Industry</span>
              </h2>
              <p className="mt-6 text-sm leading-relaxed text-charcoal/70">
                Every construction environment has different workforce requirements. Our approach is to understand
                the client's requirements before personnel are deployed, allowing us to match workforce capability
                to the specific demands of the project.
              </p>
              <p className="mt-6 font-heading text-base font-bold text-navy">
                The right workforce for the right project.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-8">
            <div className="grid sm:grid-cols-2">
              {INDUSTRIES.map((industry, i) => (
                <Reveal key={industry} delay={i * 0.04} y={20}>
                  <div
                    className="group flex items-center justify-between gap-4 border-b border-navy/10 py-5 pr-2 transition-colors duration-300 hover:border-gold"
                    data-testid={`industry-item-${i}`}
                  >
                    <div className="flex items-baseline gap-4">
                      <span className="font-heading text-xs font-bold text-gold">{String(i + 1).padStart(2, "0")}</span>
                      <span className="font-heading text-lg font-bold text-navy transition-transform duration-300 group-hover:translate-x-1.5">
                        {industry}
                      </span>
                    </div>
                    <ArrowUpRight className="h-4 w-4 shrink-0 text-navy/25 transition-colors duration-300 group-hover:text-gold" />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
